module.exports = __webpack_public_path__ + "static/media/heart36.efcd1ba1.svg";